import queryString from 'query-string';

import config from '../utils/config';
import { getCountryLevelPage, getCityLevelPage, getAllCuisines } from '../queries/cuisines';
import { CUISINE, CUISINE_RESTAURANTS, CUISINES } from './types';

export function requestCuisineForCountry({ cuisine }) {
  return (dispatch, getState) => {
    const { locale } = getState().request;
    const { tld: country } = getState().request.country;

    return dispatch({
      type: CUISINE,
      host: config.marketingLandingPagesHost,
      endpoint: '/graphql',
      options: {
        method: 'POST',
        body: getCountryLevelPage({ cuisine, country, locale }),
      },
    });
  };
}

export function requestCuisineForCity({ cuisine, city }) {
  return (dispatch, getState) => {
    const { locale } = getState().request;
    const { tld: country } = getState().request.country;

    return dispatch({
      type: CUISINE,
      host: config.marketingLandingPagesHost,
      endpoint: '/graphql',
      options: {
        method: 'POST',
        body: getCityLevelPage({ cuisine, country, locale, city }),
      },
    });
  };
}

function buildLocationParams(location, request) {
  if (location.geohash) {
    return {
      geohash: location.geohash,
    };
  }
  if (location.postcode) {
    return {
      postcode: location.postcode,
      country_iso_code: request.country.isoCode,
    };
  }
  return {
    city_uname: location.city,
    neighborhood_uname: location.neighborhood,
  };
}

/**
 * Get restaurants for up to 2 addresses, for a given cuisine/city
 */

export function getRestaurantsByAddresses(addresses) {
  return (dispatch, getState) => {
    const options = {
      timeout: 10000,
    };

    const { request, cuisine } = getState();

    return Promise.all(
      addresses.slice(0, 2).map((address) => {
        const params = {
          ...buildLocationParams(address, request),
          restaurant_fulfillments_supported: 'true',
          reduced_supported: 'true',
        };

        return dispatch({
          type: CUISINE_RESTAURANTS,
          host: config.orderappRestaurantApiHost,
          endpoint: `/orderapp/v2/restaurants?${queryString.stringify(params)}`,
          options,
          payload: {
            address,
            city: cuisine.city,
            cuisine: cuisine.cuisine,
          },
        });
      }),
    );
  };
}

export function requestCuisinesForCountry() {
  return (dispatch, getState) => {
    const { locale } = getState().request;
    const { tld: country } = getState().request.country;

    return dispatch({
      type: CUISINES,
      host: config.marketingLandingPagesHost,
      endpoint: '/graphql',
      options: {
        method: 'POST',
        body: getAllCuisines({ locale, country }),
      },
    });
  };
}
